import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Section } from '../components/ui/Section';
import { Card } from '../components/ui/Card';
import { ContactCTA } from '../components/sections/ContactCTA';
import { services } from '../data/mock';
import { LucideIcon } from 'lucide-react';

export const ServicesPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="bg-primary-dark py-24 text-center text-white mt-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Naše Usluge</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Kompletna rešenja za vaš dom i poslovni prostor uz garanciju kvaliteta.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        <Section>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => {
              const IconComponent = (Icons as any)[service.icon] as LucideIcon;
              
              return (
                <Link key={service.id} to={service.path} className="group">
                  <Card className="h-full flex flex-col overflow-hidden hover:shadow-xl transition-shadow duration-300">
                    <div className="h-48 overflow-hidden">
                      <img 
                        src={service.image} 
                        alt={service.title} 
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                    </div>
                    <div className="p-6 flex flex-col flex-grow">
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center text-primary">
                          {IconComponent && <IconComponent size={20} />}
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary transition-colors">
                          {service.title}
                        </h3>
                      </div>
                      <p className="text-gray-600 mb-6 flex-grow leading-relaxed">
                        {service.description}
                      </p>
                      <div className="flex items-center text-secondary font-medium group-hover:translate-x-2 transition-transform">
                        Saznajte više <ArrowRight size={18} className="ml-2" />
                      </div>
                    </div>
                  </Card>
                </Link>
              );
            })}
          </div>
        </Section>
        
        <ContactCTA />
      </main>

      <Footer />
    </div>
  );
};
